import { applyCustomFonts, applyFonts } from 'app/services/fonts.service';
import store from 'app/store/store';

export function initializeFonts() {
  const typographies = store.getState().entities.typographyProgram.typography;
  applyFonts(typographies);
}

export function initializeCustomFonts() {
  const customTypographies = store.getState().entities.typographyCustomProgram.customTypography;
  applyCustomFonts(customTypographies);
}
